export default __webpack_public_path__ + "static/media/047-waiter.71ba74da.svg";